var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo, useState } from 'react';
import InputMi from "./InputMi";
import { Bouton } from "../../index";
import { eyeLine, eyeOffLine } from "../../../../fondamentaux/Icone";
var InputPassword = React.forwardRef(function (props, ref) {
    var _a = useState(false), showPassword = _a[0], setShowPassword = _a[1];
    var toggleShowPassword = function () {
        setShowPassword(!showPassword);
    };
    var renduBoutonAction = useMemo(function () {
        if (showPassword) {
            return (React.createElement(Bouton, { label: "Cacher le mot de passe", icone: eyeOffLine, onClick: toggleShowPassword }));
        }
        return (React.createElement(Bouton, { label: "Afficher le mot de passe", icone: eyeLine, onClick: toggleShowPassword }));
    }, [showPassword, toggleShowPassword]);
    return (React.createElement(InputMi, __assign({}, props, { type: showPassword ? 'text' : 'password', boutonAction: renduBoutonAction, ref: ref })));
});
export default InputPassword;
